/**
 * Firebase 配置和初始化
 * 仅在客户端使用
 */

'use client';

import { initializeApp, getApps, FirebaseApp } from 'firebase/app';
import { getAnalytics, Analytics } from 'firebase/analytics';

// Firebase 配置
export const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY || 'AIzaSyCOWP7nZ3TZS4FG2q3lzCPX7Foa4M9q8Ic',
  authDomain:
    process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN || 'fluid-shadow-474808-s8.firebaseapp.com',
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID || 'fluid-shadow-474808-s8',
  storageBucket:
    process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET || 'fluid-shadow-474808-s8.firebasestorage.app',
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID || '21630944841',
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID || '1:21630944841:web:bd1be9a7f91fa69733a198',
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID || 'G-QES1WB5X4F',
};

// 初始化 Firebase（防止重复初始化）
let app: FirebaseApp;
let analytics: Analytics | null = null;

if (typeof window !== 'undefined') {
  // 只在客户端初始化
  app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

  // Analytics 只在客户端可用
  if (typeof window !== 'undefined' && !analytics) {
    analytics = getAnalytics(app);
  }
}

export { app, analytics };
